"use strict";

PF.Widget = class Widget extends PF.Entity
	{

	constructor(options)
		{
		super(options);
		}

	init()
		{
		}


	};
